import { render, staticRenderFns } from "./UpdateAdvisoryStatusModal.vue?vue&type=template&id=2ef235f9"
import script from "./UpdateAdvisoryStatusModal.vue?vue&type=script&lang=js"
export * from "./UpdateAdvisoryStatusModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports